// extracted by mini-css-extract-plugin
export default {"list":"OverlayList_list__uw7mj"};